
import Vue from 'vue';
import { Component, InjectReactive, Prop } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import CPDueDiligenceSourceDetails from './CPDueDiligenceSourceDetails.vue';
import { DueDiligenceSourceOfWealth, SourceType } from '@/store/dueDiligence/types';
import { SourceTypes } from '@/store/dueDiligence/constants';
import { metadataNumberAdapter } from '@/utils/metadataAdapters';
import { OpenAccountMetadataOption } from '@/store/openAccount/types';
import CPDueDiligenceSourceAccordianItem from './CPDueDiligenceSourceAccordianItem.vue';
import CPOpenAccountFormProse from '../open-account/form/CPOpenAccountFormProse.vue';

@Component({
    components: {
        CPOpenAccountFormSubsection,
        CPOpenAccountFormProse,
        CPDueDiligenceSourceDetails,
        CPDueDiligenceSourceAccordianItem
    }
})
export default class CPDueDiligenceSource extends Vue {
    @Prop({ required: true }) readonly title!: string;
    @Prop({ required: true, type: String }) readonly sourceType!: SourceType;
    @InjectReactive() public readonly viewOnly!: boolean;

    sourceTypes = SourceTypes;

    get sourceItems(): DueDiligenceSourceOfWealth[] {
        return this.sourceType === SourceTypes.Wealth ? 
            this.$store.state.dueDiligence.details.SourceOfWealth : 
            this.$store.state.dueDiligence.details.SourceOfFunds;
    }

    get sourceOptions(): OpenAccountMetadataOption<number>[] {
        return this.$store.getters['dueDiligence/sourceOfFundOptions'].map(metadataNumberAdapter);
    }

    addItem(event: DueDiligenceSourceOfWealth) {  
        this.$store.commit('dueDiligence/addSourceItem', {
            type: this.sourceType,
            item: event
        }); 
    }

    removeItem(event: number) {
        this.$store.commit('dueDiligence/removeSourceItem', {
            type: this.sourceType,
            id: event
        }); 
    }

    updateRemarks(event: { id: number; remarks: string }) {
        this.$store.commit('dueDiligence/setSourceItemRemarks', {
            id: event.id,
            remarks: event.remarks
        });
    }
}
